export default "__VITE_ASSET__a8afaf62__"